import { Component } from 'react';
import { consumer } from '~/lib/rails-actioncable';
import { WRModals } from '~/components/wr-modals/wr-modals-container';
import AssetPickerTypes from '~/components/common/asset-picker/asset-picker-types';
import AcademyThemeContent from '../common/academy-theme-content';
import withAcademyTheme, { doesUserNeedsToPurchaseContent } from '../common/with-academy-theme';
import AcademyGuideOverview from './academy-guide-overview';

class AcademyLearnerContentOverviewInner extends Component {
  constructor(props) {
    super(props);

    this.state = {
      assignment: props.assignment,
    };
    this.updateSubscription = null;
  }

  componentDidMount() {
    const { assignment } = this.state;

    if (this.props.failedAccessMsg) {
      setTimeout(() => WRModals.alert(this.props.failedAccessMsg), 50);
    }

    if (assignment) {
      this.updateSubscription = consumer.subscriptions.create(
        {
          channel: assignment.updatedChannelName,
          assignment_id: assignment.id,
          updated_at: assignment.updatedAt,
        },
        {
          // `data` is a rendered Assignment
          received: (data) => {
            this.updateAssignmentInState(data);
            // TODO: work out if it's possible to update the banner stats
          },
        },
      );
    }
  }

  componentWillUnmount() {
    if (this.updateSubscription) {
      consumer.subscriptions.remove(this.updateSubscription);
      this.updateSubscription = null;
    }
  }

  updateAssignmentInState = (updatedAssignment) => {
    if (!updatedAssignment) return;

    this.setState((state) => {
      const staleUpdateValue = state.assignment && state.assignment.updatedAt > updatedAssignment.updatedAt;
      if (staleUpdateValue) return {};

      return {
        assignment: {
          ...state.assignment,
          ...updatedAssignment,
        },
      };
    });
  };

  render() {
    if (this.props.msg) return this.renderBlankPage();

    return (
      <AcademyThemeContent
        style={{
          paddingTop: '25px',
        }}
      >
        {this.renderContentOverview()}
      </AcademyThemeContent>
    );
  }

  renderContentOverview = () => {
    const { academy, academyContent, customPageSlug, purchasableContentInfo } = this.props;
    const { assignment } = this.state;
    const userNeedsToPurchaseContent = doesUserNeedsToPurchaseContent(purchasableContentInfo);

    const urlParams = new URLSearchParams(window.location.search);
    const certificationId = urlParams.get('certification_id');

    switch (academyContent.contentType) {
      case AssetPickerTypes.RESOURCE:
        return null;
      case AssetPickerTypes.GUIDE:
      default:
        return (
          <AcademyGuideOverview
            assignment={assignment}
            academyContent={academyContent}
            certificationId={certificationId}
            customPageSlug={customPageSlug}
            guide={academyContent.content}
            themeOptions={academy.themeOptions}
            userNeedsToPurchaseContent={userNeedsToPurchaseContent}
          />
        );
    }
  };

  renderBlankPage = () => <div className="mtxl text-center grey-5 fsm">{this.props.msg}</div>;
}

const AcademyLearnerContentOverview = withAcademyTheme(AcademyLearnerContentOverviewInner);

export default AcademyLearnerContentOverview;
